import { BackrsUser } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export type SuperCoachAssigneesResponse = BackrsUser[];

export interface SuperCoachAssigneesFilter {
  q?: string;
}

export interface EmulationTokenResponse {
  access_token: string;
  session_id: string;
}

export const superCoachApi = createApi({
  reducerPath: 'superCoachApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['SuperCoachAssignees', 'EmulationToken'],
  endpoints: (builder) => ({
    fetchSuperCoachAssignees: builder.query<
      SuperCoachAssigneesResponse,
      SuperCoachAssigneesFilter | undefined
    >({
      query: (filter) => {
        const params = new URLSearchParams();

        if (filter && Object.keys(filter).length > 0) {
          params.append('filter', JSON.stringify(filter));
        }

        const queryString = params.toString();
        const url = `/super-coach-assignees/my-assignees${queryString ? `?${queryString}` : ''}`;

        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (response: BackrsUser[]): SuperCoachAssigneesResponse => {
        // Sort users alphabetically by full name
        return response.sort((a, b) =>
          `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`),
        );
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'SuperCoachAssignees' as const, id })),
              { type: 'SuperCoachAssignees', id: 'LIST' },
            ]
          : [{ type: 'SuperCoachAssignees', id: 'LIST' }],
    }),
    requestEmulationToken: builder.mutation<EmulationTokenResponse, string>({
      query: (userId) => ({
        url: `/auth/emulation`,
        method: 'POST',
        body: { user_id: userId },
      }),
      invalidatesTags: ['EmulationToken'],
    }),
  }),
});

// Export the hooks and middleware
export const {
  useFetchSuperCoachAssigneesQuery,
  useRequestEmulationTokenMutation,
  util: { resetApiState: resetSuperCoachApiState },
} = superCoachApi;
